import { useState } from "react";
import Sidebar from "../components/sidebar";

const DashboardLayout = (props) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
    console.log("Toggling collapse. New value:", !isCollapsed);
  };

  return (
    <div className="flex">
      <div
        className={`fixed top-0 left-0 z-50 h-screen p-6 transition-all duration-300 ${
          isCollapsed ? "w-[280px]" : "w-auto"
        }`}
      >
        <Sidebar isCollapsed={isCollapsed} toggleCollapse={toggleCollapse} />
      </div>
      <div
        className={`flex-1 transition-all duration-300 ${
          isCollapsed ? "ml-0" : "ml-[304px]"
        }`}
      >
        <div className="flex-1 transition-all duration-300  ">
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
